module.exports = __webpack_public_path__ + "images/half_van_3.svg";